var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuBars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0011 9.01904C12.5534 9.01904 13.0011 9.46676 13.0011 10.019V20.019C13.0011 20.5713 12.5534 21.019 12.0011 21.019C11.4488 21.019 11.0011 20.5713 11.0011 20.019V10.019C11.0011 9.46676 11.4488 9.01904 12.0011 9.01904Z",
    fill: "#BB85FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0011 3.01904C18.5534 3.01904 19.0011 3.46676 19.0011 4.01904V20.019C19.0011 20.5713 18.5534 21.019 18.0011 21.019C17.4488 21.019 17.0011 20.5713 17.0011 20.019V4.01904C17.0011 3.46676 17.4488 3.01904 18.0011 3.01904Z",
    fill: "#BB85FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0011 15.019C6.55338 15.019 7.0011 15.4668 7.0011 16.019V20.019C7.0011 20.5713 6.55338 21.019 6.0011 21.019C5.44881 21.019 5.0011 20.5713 5.0011 20.019V16.019C5.0011 15.4668 5.44881 15.019 6.0011 15.019Z",
    fill: "#BB85FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBars);
export default __webpack_public_path__ + "static/media/menu-bars.8f2d984443f8b5857f1e948ef176fc88.svg";
export { ForwardRef as ReactComponent };